import {
  FaWandMagicSparkles as AiAssistant,
  FaVideo as LivePanel,
  FaSliders as AdaptiveLearning,
  FaUserGear as PersonalizedLearning,
  FaChartLine as InsightsAnalytics,
  FaFolderTree as ContentManagement,
  FaHeadset as StudentSupport,
  FaUniversalAccess as Accessibility,
  FaChalkboardUser as Professor,
  FaChalkboard as Lecturer,
  FaUserCheck as Instructor,
  FaSitemap as DepartmentHead,
  FaFileLines as DynamicFormsIcon,
  FaUserShield as RoleAccessIcon,
  FaRobot as AiProcessingIcon,
  FaComments as ChatAssistantIcon,

  FaStopwatch as SavesTimeIcon,
  FaWandMagicSparkles as SmartAutofillIcon,
  FaListCheck as SimplifiesFormsIcon,
  FaMobileScreenButton as MobileFriendlyIcon,
  FaShieldHalved as SecurePrivateIcon,
  FaPaperPlane as SubmissionTrackingIcon,
  FaMoneyCheckDollar as FinancialAidIcon,
  FaClipboardList as CourseRegistrationIcon,
  FaBriefcase as InternshipIcon,
  FaHouseMedical as HealthHousingIcon,
  FaPlane as StudyAbroadIcon,

  FaUserClock as ProactiveUpdatesIcon,
  FaChartLine as AdminDashboardIcon,
  FaUsers as StudentSupportIcon,
  FaGlobe as AccessibilityIcon,
  FaShieldHalved as SecureIcon,
  FaLanguage as LanguageSupportIcon,
  FaComments as ChatbotIcon,
  FaGraduationCap as TutorialsIcon,
  FaHeadset as LiveAgentIcon,

  FaUserGroup as StudentEngagementIcon,  // ✅ replaces FaUserFriends again
  FaBrain as CampusSolutionsIcon,
  FaLink as IntegrationsIcon,
  FaLightbulb as LearningAssistIcon,
  FaBell as NotificationsIcon,
  FaCircleQuestion as QueryResolutionIcon // ✅ correct FA6 name

} from "react-icons/fa6";
import { TbFileExport as Export, TbShieldCheck as ComplianceSecurity } from "react-icons/tb";
import { MdAutoMode as Automation, MdAssistant as TeachingAssistant } from "react-icons/md";
import { FaUniversity as CollegeAdmissionsIcon, } from "react-icons/fa"


import { 
  lxp_hero,
  aiforms_hero,
  lms_f1,
  lms_f2,
  lms_f3,
  lms_f4,
  forms_f1,
  forms_f2,
  forms_f3,
  aiassistant_f1,
  aiassistant_f2,
  aiassistant_f3,
  aiassistant_f4,
  lxp_benefits, 
  aiforms_benefits
  } from "../../assets/images";

export const productsData = [
   {
    slug: "ai-lms",
    title: "LXP",
    downloadUrl: "/docs/ailms-flayer.pdf",
    hero: {
      header: "LXP (Learning eXperience Platform): Smarter learning paths, seamless content flow",
      image: lxp_hero,
      isbutton: true,
      description:
        "This AI-powered course builder enables teachers to quickly create modules, lessons, and quizzes with real-time collaborative editing through an embedded live panel."
    },
    features: [
      {
        icon: AiAssistant,
        title: "AI Assistant for Course Design",
        image: lms_f1,
        description:
          "Quickly generate course modules, weekly lessons, and quizzes with AI support. Educators can spend less time drafting and more time refining content for impact.",
      },
      {
        icon: LivePanel,
        title: "Embedded Live Panel",
        image: lms_f2,
        description:
          "An AI panel is built directly into the course page, allowing teachers to chat with AI while updating their modules in real time. The flexible panel layout creates a seamless and focused workflow.",
      },
      {
        icon: Export,
        title: "LMS-Compatible Export",
        image: lms_f3,
        description:
          "Export generated content into LMS-friendly formats, including Canvas-ready files. Teachers can import courses with minimal effort, cutting down on manual formatting and setup.",
      },
      {
        icon: AdaptiveLearning,
        title: "Adaptive & Personalized Learning",
        image: lms_f4,
        description:
          "Deliver tailored content and adaptive learning paths for every student. By analyzing learner progress, the system can recommend personalized adjustments that drive engagement and outcomes.",
      }
    ],
    benefits: {
      title: "Key Benefits of LXP for Educators",
      benefitsImage: lxp_benefits,
      benefitList: [
        {
          icon: PersonalizedLearning,
          title: "Personalized Learning at Scale",
          points: [
            "Automatically adapts content to each student’s pace, performance, and learning style",
            "Enables differentiated instruction without increasing workload",
            "Supports inclusive teaching by identifying and accommodating diverse learner needs"
          ]
        },
        {
          icon: Automation,
          title: "Time-Saving Automation",
          points: [
            "Reduce manual course setup through intelligent automation",
            "Automate repetitive teaching and grading tasks",
            "Free up educators’ time for higher-value activities"
          ]
        },
        {
          icon: InsightsAnalytics,
          title: "Actionable Insights & Analytics",
          points: [
            "Real-time data on learner progress",
            "Identify at-risk students early",
            "Improve teaching strategies with data-driven decisions"
          ]
        },
        {
          icon: ContentManagement,
          title: "Smarter Content Management",
          points: [
            "Organize and update course content efficiently",
            "Reuse and adapt materials across courses",
            "Streamline course-building workflows"
          ]
        },
        {
          icon: StudentSupport,
          title: "Enhanced Student Support",
          points: [
            "24/7 assistance through AI tools",
            "Quickly answer student queries",
            "Offer proactive guidance"
          ]
        },
        {
          icon: ComplianceSecurity,
          title: "Improved Compliance & Security",
          points: [
            "Ensure data privacy and FERPA compliance",
            "Secure course content and student data",
            "Stay aligned with institutional policies"
          ]
        },
        {
          icon: Accessibility,
          title: "Flexibility & Accessibility",
          points: [
            "Accessible across devices and platforms",
            "Inclusive design for diverse learning needs",
            "Enable flexible teaching and learning models"
          ]
        }
      ]
    },
    useCases: [
      {
        icon: Professor,
        title: "Professor",
        description: "Focus more on teaching and research, less on admin"
      },
      {
        icon: Lecturer,
        title: "Lecturer",
        description: "Deliver engaging, personalized lessons with minimal prep"
      },
      {
        icon: Instructor,
        title: "Instructor",
        description: "Track progress and intervene early with struggling students"
      },
      {
        icon: TeachingAssistant,
        title: "Teaching Assistant",
        description: "Automate grading and support tasks efficiently",
        comingSoon: true
      },
      {
        icon: DepartmentHead,
        title: "Department Head",
        description: "Monitor course performance and ensure instructional quality"
      }
    ]
   },
   
  {
    slug: "smart-forms",
    title: "Smart Forms",
    downloadUrl: "",
    hero: {
      header: "Smart Forms: Simplifying Data and Form Processes",
      image: aiforms_hero,
      isbutton: false,
      description:
        "Build dynamic, AI-driven forms and data collection widgets that streamline creation, management, and submission while reducing workload and enhancing efficiency."
    },

    features: [
      {
        icon: DynamicFormsIcon,
        title: "Dynamic Form Creation",
        description:
          "Create interactive forms and data collection widgets that adapt to user inputs and preferences, ensuring personalized and efficient workflows.",
        image: forms_f1
      },
      {
        icon: RoleAccessIcon,
        title: "Secure Role-Based Access",
        description:
          "Integrate with your identity provider (e.g., Microsoft Entra ID) so users only see and complete the forms relevant to their role, while admins can manage, track, and process.",
        image: forms_f2
      },
      {
        icon: AiProcessingIcon,
        title: "AI-Powered Processing",
        description:
          "Leverage AI to pre-fill forms, auto-complete fields, and use past submissions for faster, more accurate completion with minimal manual effort.",
        image: forms_f3
      },
      {
        icon: ChatAssistantIcon,
        title: "Intelligent Chat Assistant",
        description:
          "Enable users to interact with an AI assistant that guides them through form access, completion, and submission—making the process intuitive and seamless.",
        image: lxp_benefits
      }
    ],

    benefits: {
      title: "Key Benefits of Smart Forms for Students",
      benefitsImage: aiforms_benefits,
      benefitList: [
        {
          icon: SavesTimeIcon,
          title: "Saves Time on Repetitive Tasks",
          points: [
            "Automatically fills common fields like name, address, student ID, and course info",
            "Reduces the need to re-enter the same data across multiple forms (e.g., financial aid, registration, housing)"
          ]
        },
        {
          icon: SmartAutofillIcon,
          title: "Smart Autofill with Context Awareness",
          points: [
            "Understands the form’s context to suggest relevant values",
            "Learns from prior submissions to improve accuracy over time"
          ]
        },
        {
          icon: SimplifiesFormsIcon,
          title: "Simplifies Complex Forms",
          points: [
            "Breaks long forms into guided steps",
            "Highlights required fields and prevents common validation errors"
          ]
        },
        {
          icon: MobileFriendlyIcon,
          title: "Mobile-Friendly & Accessible",
          points: [
            "Optimized for phones and tablets with responsive layouts",
            "Inclusive, accessible design for diverse learning needs"
          ]
        },
        {
          icon: SecurePrivateIcon,
          title: "Secure & Private",
          points: [
            "Role-based permissions and least-privilege access",
            "Encryption and compliance-aligned handling of student data"
          ]
        },
        {
          icon: SubmissionTrackingIcon,
          title: "Integrated Submission & Tracking",
          points: [
            "Track status and receive reminders/notifications",
            "Export and share submissions with institutional systems"
          ]
        }
      ]
    },

    useCases: [
      {
        icon: CollegeAdmissionsIcon,
        title: "College admissions and enrollment forms",
        description: "Streamline application, enrollment, and onboarding paperwork"
      },
      {
        icon: FinancialAidIcon,
        title: "Financial aid and FAFSA documentation",
        description: "Accelerate aid applications with accurate autofill and reminders"
      },
      {
        icon: CourseRegistrationIcon,
        title: "Course registration and add/drop requests",
        description: "Reduce errors and speed up approvals with guided steps"
      },
      {
        icon: InternshipIcon,
        title: "Internship and job application forms",
        description: "Auto-fill profiles, experience, and references across forms"
      },
      {
        icon: HealthHousingIcon,
        title: "Health and housing forms",
        description: "Handle medical disclosures and housing requests securely"
      },
      {
        icon: StudyAbroadIcon,
        title: "Study abroad and travel documentation",
        description: "Centralize visa, travel, and program documents with tracking"
      }
    ]
  },

  {
    slug: "ai-assistant",
    title: "AI Assistant",
    downloadUrl: "/docs/aiassistant_flyer.pdf",
    hero: {
      header: "AI Assistant: Smarter Conversations, Deeper Insights, Better Outcomes",
      image: lxp_hero,
      isbutton: true,
      description:
        "Empowering campus communities with intelligent, automated 24/7 AI chat support to guide students, reduce administrative workload, and improve engagement."
    },

    features: [
      {
        icon: LanguageSupportIcon,
        title: "Multi-Channel & Language Support",
        description:
          "Seamlessly engage students across platforms in their preferred language, ensuring accessibility and inclusivity.",
        image: aiassistant_f1
      },
      {
        icon: ChatbotIcon,
        title: "Conversational AI Assistance",
        description:
          "AI-powered, multilingual chatbots enable smart follow-ups and multi-turn conversations for deeper engagement.",
        image: aiassistant_f2
      },
      {
        icon: TutorialsIcon,
        title: "Student Tutorials & Resources",
        description:
          "Access a rich library of videos, guides, and documentation to help students navigate tools and processes independently.",
        image: aiassistant_f3
      },
      {
        icon: LiveAgentIcon,
        title: "Live Agent Handoff & Secure History",
        description:
          "Get timely human support when needed while maintaining private, authorized access to past conversations for continuity.",
        image: aiassistant_f4
      }
    ],

    benefits: {
      title: "Key Benefits of AI Assistant for Educators",
      benefitsImage: lxp_benefits,
      benefitList: [
        {
          icon: ProactiveUpdatesIcon,
          title: "Personalized, Proactive Student Updates",
          points: [
            "Keep students informed with smart reminders and progress updates",
            "Build stronger engagement through automated personalized communication"
          ]
        },
        {
          icon: AdminDashboardIcon,
          title: "Unified Admin Dashboard",
          points: [
            "Monitor chat insights, usage patterns, and student engagement metrics",
            "Simplify management of student interactions and response quality"
          ]
        },
        {
          icon: StudentSupportIcon,
          title: "Improved Student Support",
          points: [
            "Reduce staff workload with 24/7 AI support for common queries",
            "Provide consistent, accurate responses instantly"
          ]
        },
        {
          icon: AccessibilityIcon,
          title: "Multilingual Accessibility",
          points: [
            "Support multiple languages to ensure inclusivity",
            "Adapt tone and vocabulary to match student communication styles"
          ]
        },
        {
          icon: SecureIcon,
          title: "Secure & Compliant",
          points: [
            "Maintain data privacy and FERPA compliance",
            "Safeguard student chat histories with encrypted storage"
          ]
        }
      ]
    },

    useCases: [
      {
        icon: StudentEngagementIcon,
        title: "Student Support & Engagement",
        description:
          "Stay connected with 24/7 AI assistance for questions, guidance, and campus resources—no more waiting in queues."
      },
      {
        icon: CampusSolutionsIcon,
        title: "AI-Powered Campus Solutions",
        description:
          "Simplify operations using AI tools for form automation, transcript evaluation, and student support."
      },
      {
        icon: IntegrationsIcon,
        title: "Seamless Integrations",
        description:
          "Connect CRM, SIS, and LMS systems for a unified, streamlined campus experience."
      },
      {
        icon: LearningAssistIcon,
        title: "Personalized Learning Assistance",
        description:
          "Get AI-guided recommendations for courses, study plans, and resources tailored to each student’s needs."
      },
      {
        icon: NotificationsIcon,
        title: "Proactive Notifications & Reminders",
        description:
          "Keep students informed with automated alerts for deadlines, events, and important updates."
      },
      {
        icon: QueryResolutionIcon,
        title: "Efficient Query Resolution",
        description:
          "AI chatbots handle common student inquiries instantly, freeing staff to focus on complex issues."
      }
    ]
  }


];
